module.exports = __webpack_public_path__ + "img/mypage.5561f32a.png";